import it from "./it";

const en: typeof it = {
  common: {
    action: "Action",
    delete: "Delete",
    edit: "Edit",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    yes: "Yes",
    no: "No",
    search: "Search",
    reset: "Reset",
    actionExecutedSuccessfully: "Action performed successfully",
    error: "Something went wrong. Please try again",
    requiredField: "Required field",
    cleanFilters: "Remove filters",
    refresh: "Refresh",
    create: "Create",
    backToLogin: "Back to login",
    next: "Next",
    back: "Back",
    upload: "Upload",
    close: "Chiudi",
    continue: "Continua",
    dndMessage: "Drag 'n' drop some files here, or click to select files",
    deletePopUp: "Delete permanently?",
    add: "Add",
    signOut: "Sign Out",
    loading: "Loading...",
  },
  components: {
    common: {
      programModal: {
        typeNew: "New program",
        typeEdit: "Edit program",
      },
      programForm: {
        title: "Title",
        description: "Description",
        url: "Url",
        posterUrl: "Cover image",
        trailer: "Trailer",
        trailerUrl: "Trailer (URL)",
        trailerInfo:
          "Select a collection before assigning a trailer to the show",
        categories: "Category",
        typology: "Typology",
        movie: "Movie",
        tvShow: "TV Show",
        numberOfSeason: "Number of season",
        bannerId: "Banner",
        adCircuitId: "Ad circuit",
        validFrom: "Valitd to",
        validUntil: "Valitd from",
        mustSee: "Must see",
        tags: "Tags",
        isVipOnly: "Vip only",
        titlePlaceholder: "Insert the title",
        descriptionPlaceholder: "Insert the description",
        urlPlaceholder: "Insert the url",
        posterUrlPlaceholder: "Insert the cover image ",
        categoriesPlaceholder: "Select the categories",
        numberOfSeasonPlaceholder: "Select a season",
        bannerIdPlaceholder: "Select banner",
        adCircuitIdPlaceholder: "Select an ad circuit",
        validFromPlaceholder: "Insert the date",
        validUntilPlaceholder: "Insert the date",
        tagsPlaceholder: "Insert the tags",
        titleRequired: "Title required",
        urlRequired: "Url required",
        posterUrlRequired: "Cover image link required",
        categoriesRequired: "Category required",
        numberOfSeasonRequired: "Number of season required",
        validFromRequired: "Start validation date required",
        validUntilRequired: "End validation date required",
      },
      advertisingCircuitModal: {
        typeNew: "New advertising circuit",
        typeEdit: "Edit advertising circuit",
      },
      advertisingCircuitForm: {
        title: "Title",
        description: "Description",
        createdAt: "Date creation",
        updateAt: "Date update",
        titlePlaceholder: "Insert the title",
        descriptionPlaceholder: "Insert the description",
        createdAtPlaceholder: "Insert the date",
        updateAtPlaceholder: "Insert the date",
        titleRequired: "Title required",
        createdAtRequired: "Date required",
        updateAtRequired: "Date required",
      },
      menuLinkModal: {
        typeNew: "New menu link",
        typeEdit: "Edit menu link",
      },
      menuLinkForm: {
        icon: "Icon",
        name: "Name",
        onClickUrl: "Url",
        category: "Program Category",
        multimediaCategory: "Episode Category",
        program: "Program",
        episode: "Episode",
        namePlaceholder: "Insert the name",
        onClickUrlPlaceholder: "Insert the url",
        categoryPlaceholder: "Select the category",
        iconRequired: "Icon required",
        nameRequired: "Name required",
        langRequired: "Language required",
        onClickUrlCategoryRequired: "Url or category required",
      },
      footerModal: {
        typeNew: "New footer row",
        typeEdit: "Edit footer row",
      },
      footerForm: {
        html: "Html",
        orderNumber: "Display order",
        htmlPlaceholder: "Insert the html",
        htmlRequired: "Html required",
        orderNumberRequired: "Display order required",
      },
      streamingForm: {
        state: "State",
        active: "Active",
        notActive: "Not active",
        url: "Url",
        urlPlaceholder: "Insert the url",
        coverUrl: "Cover image",
        coverUrlPlaceholder: "Insert the cover image",
        urlRequired: "Url required",
        coverUrlRequired: "Cover image required",
      },
      firestickConfigForm: {
        category: "Title",
        logoImg: "Logo image",
        streamingImg: "Streaming image",
        description: "Description",
        categoryRequired: "Title required",
        categoryPlaceholder: "Insert the title",
        logoImgRequired: "Logo image required",
        logoImgPlaceholder: "Insert the logo url",
        streamingImgRequired: "Streaming image required",
        streamingImgPlaceholder: "Insert the cover image",
        descriptionRequired: "Description required",
        descriptionPlaceholder: "Insert the description",
      },
    },
    SigninForm: {
      title: "Sign In",
      description: "Welcome back! Please signin to continue.",
      email: "Email",
      password: "Password",
      emailPlaceholder: "Insert your mail",
      emailRequired: "Email is required",
      emailInvalid: "Invalid email address",
      passwordPlaceholder: "Insert your password",
      forgotPassword: "Forgot password?",
      passwordRequired: "Password is required",
      passwordInvalid: "Minimum length is 8",
    },
    ForgotPasswordForm: {
      title: "Reset your password",
      description:
        "Enter your username or email address and we will send you a link to reset your password.",
      password: "Reset Password",
      passwordPlaceholder: "Type your Password",
    },
    changePasswordForm: {
      title: "Change your password",
      description: "Welcome back! Please signin to continue.",
      newPassword: "New password",
      passwordPlaceholder: "Type your Password",
      confirmPassword: "Confirm password",
      button: "Change password",
    },
    categoryModal: {
      typeNew: "New category",
      typeEdit: "Modify category",
    },
    categoryForm: {
      name: "Name",
      orderNumber: "Display order",
      state: "State",
      visibleInApp: "Visible",
      notVisibleInApp: "Not visible",
      namePlaceholder: "Insert a name",
      nameRequired: "Name required",
      langRequired: "Language required",
      visibleInAppRequired: "Mandatory choice",
      orderPlaceholder: "Insert the display order",
      orderNumberRequired: "Display order required",
      programsOrder: "Programs display order",
      multimediaOrder: "Multimedia display order",
      olderProgramsFirst: "Show older programs first",
      newestProgramsFirst: "Show newest programs first",
      olderMultimediaFirst: "Show older multimedia first",
      newestMultimediaFirst: "Show newest multimedia first",
    },
    articleForm: {
      title: "Title",
      description: "Description",
      image: "Image",
      category: "Category",
      categoryPlaceholder: "Insert the category",
      titlePlaceholder: "Insert the title",
      descriptionPlaceholder: "Insert the description",
      titleRequired: "Title required",
      descriptionRequired: "Description required",
      imageRequired: "Image required",
    },
    screenProgramDetail: {
      videoModal: {
        typeNew: "New video",
        typeEdit: "Edit video",
      },
      videoForm: {
        title: "Title",
        description: "Description",
        url: "Video",
        videoFolder: "Video folder",
        posterUrl: "Cover image link",
        inAppUrl: "In app url",
        highlighted: "Highlighted",
        isHighlighted: "Highlighted",
        isNotHighlighted: "Not highlighted",
        season: "Season",
        episodeNumber: "Episode number",
        duration: "Duration",
        validFrom: "Valitd to",
        validUntil: "Valitd from",
        coverImage: "Cover image",
        titlePlaceholder: "Insert the title",
        descriptionPlaceholder: "Insert the description",
        urlPlaceholder: "Insert the video",
        posterUrlPlaceholder: "Insert the cover image link",
        inAppUrlPlaceholder: "Insert the url",
        highlightedPlaceholder: "Choose an option",
        seasonPlaceholder: "Insert the  season",
        episodeNumberPlaceholder: "Insert the episode number",
        durationPlaceholder: "Insert the duration",
        validFromPlaceholder: "Insert the date",
        validUntilPlaceholder: "Insert the date",
        titleRequired: "Title required",
        urlRequired: "Video required",
        posterUrlRequired: "Cover image link required",
        inAppUrlRequired: "In app url required",
        highlightedRequired: "Highlighted required",
        seasonRequired: "Season required",
        episodeNumberRequired: "Episode number required",
        durationRequired: "Duration is required",
        validFromRequired: "Start validation date required",
        validUntilRequired: "End validation date required",
        mediaType: "Media type",
        mediaUrl: "Media url",
      },
    },
    screenAdvertisingDetail: {
      adModal: {
        typeNew: "New ad",
        typeEdit: "Modify ad",
      },
      adForm: {
        title: "Title",
        description: "Description",
        url: "Url",
        posterUrl: "Cover image link",
        onClickUrl: "Share url",
        duration: "Duration",
        validFrom: "Valitd to",
        validUntil: "Valitd from",
        canBeSkipped: "Can be skipped?",
        isCanBeSkipped: "Can be skipped",
        isNotCanBeSkipped: "Can not be skipped",
        titlePlaceholder: "Insert the title",
        descriptionPlaceholder: "Insert the description",
        urlPlaceholder: "Insert the url",
        posterUrlPlaceholder: "Insert the cover image link",
        onClickUrlPlaceholder: "Insert the share url",
        durationPlaceholder: "Insert the Duration",
        validFromPlaceholder: "Insert the date",
        validUntilPlaceholder: "Insert the date",
        canBeSkippedPlaceholder: "Choose an option",
        titleRequired: "Title required",
        urlRequired: "Url required",
        posterUrlRequired: "Cover image link required",
        onClickUrlRequired: "Share url required",
        durationRequired: "Duration required",
        validFromRequired: "Start validation date required",
        validUntilRequired: "End validation date required",
        canBeSkippedRequired: "Can be skipped required",
      },
    },
    screenUser: {
      userForm: {
        nominative: "Nominative",
        nominativePlaceholder: "Insert the Nominative",
        email: "Email",
        emailPlaceholder: "Insert the mail",
        password: "Password",
        passwordPlaceholder: "Insert the password",
        userValidations: {
          nominativeRequired: "Nominative required",
          emailRequired: "Email required",
        },
      },
    },
    screenBanners: {
      bannerModal: {
        typeNew: "Nuovo banner",
        typeEdit: "Modifica banner",
      },
      bannerForm: {
        title: "Title",
        description: "Description",
        imageUrl: "Url image banner",
        onClickUrl: "Share url",
        createdAt: "Creation date",
        validFrom: "Valid from",
        validUntil: "Valid until",
        titlePlaceholder: "Insert the title",
        descriptionPlaceholder: "Insert the description",
        imageUrlPlaceholder: "Insert the share url",
        onClickUrlPlaceholder: "Insert the url",
        createdAtPlaceholder: "Insert the date",
        validFromPlaceholder: "Insert the date",
        validUntilPlaceholder: "Insert the date",
        titleRequired: "Title required",
        imageUrlRequired: "Image url required",
        onClickUrlRequired: "Share url required",
        createdAtRequired: "Creation date required",
        validFromRequired: "Start validation date required",
        validUntilRequired: "End validation date required",
      },
    },
    screenMediaList: {
      uploadMediaModal: {
        title: "Upload video",
      },
    },
    screenPushNotifications: {
      pushNotificationsModal: {
        new: "New push notification",
      },
      pushNotificationsForm: {
        title: "Title",
        titlePlaceholder: "Insert the title",
        titleRequired: "Title required",
        titleMaxLength: "Title max length is 50",
        message: "Message",
        messagePlaceholder: "Insert the message",
        messageRequired: "Message required",
        messageMaxLength: "Message max length is 150",
      },
    },
  },
  screens: {
    programCategories: {
      pageHeader: {
        title: "Programs categories",
        buttonText: "New",
      },
      breadcrumb: {
        home: "Home",
        programCategories: "Programs categories",
      },
      column: {
        name: "Name",
        order: "Display order",
        visible: "Visibility",
        visibleActive: "Visible",
        visibleNotActive: "Not visible",
      },
      emptyData: "No program category available in the system",
    },
    multimediaCategories: {
      pageHeader: {
        title: "Multimedia categories",
        buttonText: "New",
      },
      breadcrumb: {
        home: "Home",
        multimediaCategories: "Multimedia categories",
      },
      column: {
        name: "Name",
        order: "Display order",
        visible: "Visibility",
        visibleActive: "Visible",
        visibleNotActive: "Not visible",
      },
      emptyData: "No episode category available in the system",
    },
    articles: {
      title: "Title",
      author: "Author",
      data: "Data",
      options: "Options",
      pageHeader: {
        title: "Articles",
        buttonText: "New",
      },
    },
    article: {
      pageHeader: {
        titleNew: "New article",
        titleEdit: "Edit article",
      },
    },
    program: {
      pageHeader: {
        title: "Program list",
        buttonText: "New program",
      },
      column: {
        title: "Title",
        validFrom: "Start validation",
        validUntil: "End validation",
        firstDeletePopUp: "Move this program to the trash?",
        restore: "Restore",
      },
      breadcrumb: {
        home: "Home",
        programs: "Programs",
      },
      emptyData: "No program available in the system",
    },
    programDetail: {
      newEpisode: "New episode",
      newMovie: "New movie",
      pageHeader: {
        title: "Video list",
        buttonText: "Edit program",
      },
      form: {
        seasonNumberPlaceholder: "Insert number",
        seasonNumberRequired: "Number is required",
        addTab: "Aggiungi",
      },
      column: {
        title: "Title",
        url: "Url",
        videoNumber: "Episode number",
        validFrom: "Start validation",
        validUntil: "End validation",
      },
      breadcrumb: {
        home: "Home",
        programs: "Programs",
      },
      season: "Season",
      adCircuit: "Ad circuit:",
      banner: "Banner:",
      emptyData: "No episode in this season",
      emptyDataMovie: "No movie available in the system",
      deleteSeason:
        "Warning, you are about to delete the season number {{seasonNumber}} and all its episodes. Are you sure?",
    },
    users: {
      nominative: "Nominative",
      email: "Email",
      options: "Options",
      pageHeader: {
        title: "Users",
        buttonText: "New",
      },
    },
    user: {
      pageHeader: {
        titleNew: "New user",
        titleEdit: "Edit user",
      },
    },
    banners: {
      pageHeader: {
        title: "Banners list",
        buttonText: "New banner",
      },
      column: {
        title: "Title",
        validFrom: "Start validation",
        validUntil: "End validation",
      },
      breadcrumb: {
        home: "Home",
        banners: "Banners",
      },
      emptyData: "No banners available in the system",
    },
    advertisingCircuit: {
      pageHeader: {
        title: "Advertising circuit list",
        buttonText: "New advertising circuit",
      },
      column: {
        title: "Title",
      },
      breadcrumb: {
        home: "Home",
        advCircuit: "Advertising circuit",
      },
      emptyData: "No advertising circuit available in the system",
    },
    advertisingDetail: {
      newAd: "Add advertising",
      pageHeader: {
        title: "Video list",
        buttonText: "Modify advertising",
      },
      form: {
        seasonNumberPlaceholder: "Insert the seasons number",
        seasonNumberRequired: "Season number required",
        addTab: "Add",
      },
      column: {
        title: "Title",
        url: "Url",
        validFrom: "Valido da",
        validUntil: "Valido a",
      },
      breadcrumb: {
        home: "Home",
        adCircuit: "Advertising circuits",
      },
      season: "Season",
      emptyData: "No advertising available in the system",
    },
    mediaList: {
      breadcrumb: {
        home: "Home",
        media: "Media",
      },
      pageHeader: {
        title: "Media",
        buttonText: "Upload",
      },
      column: {
        title: "Title",
      },
      emptyData: "No media",
    },
    iconsList: {
      breadcrumb: {
        home: "Home",
        icons: "Icons",
      },
      pageHeader: {
        title: "Icons",
        buttonText: "Upload",
      },
      column: {
        title: "Icona",
      },
      emptyData: "No icons",
    },
    menuLink: {
      pageHeader: {
        title: "Menu link",
        buttonText: "New",
      },
      column: {
        icon: "Icon",
        name: "Name",
        onClickUrl: "Url",
        category: "Category",
      },
      breadcrumb: {
        home: "Home",
        menuLinks: "Menu links",
      },
      emptyData: "No menu link available in the system",
    },
    footer: {
      pageHeader: {
        title: "Footer rows",
        buttonText: "New",
      },
      column: {
        orderNumber: "Display order",
        html: "html",
      },
      breadcrumb: {
        home: "Home",
        footer: "Footer rows",
      },
      emptyData: "No footer rows available in the system",
    },
    streaming: {
      pageHeader: {
        title: "Streaming config",
        buttonText: "New",
      },
      breadcrumb: {
        home: "Home",
        streaming: "Streaming config",
      },
    },
    firestickConfig: {
      pageHeader: {
        title: "Firestick app config",
        buttonText: "New",
      },
      breadcrumb: {
        home: "Home",
        firestickConfig: "Firestick app config",
      },
    },
    pushNotifications: {
      pageHeader: {
        title: "Push notifications",
        buttonText: "New notification",
      },
      breadcrumb: {
        home: "Home",
        pushNotifications: "Push notifications",
      },
      column: {
        id: "id",
        title: "Title",
        message: "Message",
        createdAt: "Created at",
      },
      emptyData: "No push notification available in the system",
    },
  },
  // If necessary
  messages: {
    formValidations: {
      form1: {
        key: "message",
      },
    },
    ui: {
      key: "message",
      vimeoMediaListError: "Vimeo error. Episodes list could not be downloaded",
      vimeoMediaFoldersError:
        "Vimeo error. Video folder could not be downloaded",
      vimeoUserError: "Vimeo error. User data could not be downloaded",
    },
  },
};

export default en;
